import React from 'react';

// This is Facebook's logo, you are not allowed to change its color
export const QviroLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-name="Layer 1"
    version="1.1"
    viewBox="0 0 686.01 743.65"
    width="20" height="20"
  >
    <defs>
      <linearGradient id="linearGradient4015">
        <stop offset="0.161" stopColor="#8b2c32" stopOpacity="1"></stop>
        <stop offset="1" stopColor="#c59398" stopOpacity="1"></stop>
      </linearGradient>
      <linearGradient
        id="linearGradient4016"
        x1="707.982"
        x2="1393.992"
        y1="582.556"
        y2="582.556"
        gradientTransform="translate(-707.982 -2)"
        gradientUnits="userSpaceOnUse"
        xlinkHref="#linearGradient4015"
      ></linearGradient>
    </defs>
    <path
      fill="url(#linearGradient4016)"
      fillOpacity="1"
      stroke="none"
      strokeDasharray="none"
      strokeOpacity="1"
      strokeWidth="1.002"
      d="M127.283 419.46c-42.157.55-86.465-1.095-127.283.82.26 32.878-3.012 67.744 13.889 97.732 13.948 30.22 41.854 49.812 70.482 64.717 61.778 35.196 122.783 71.839 185.106 106.019 40.618 18.651 89.273 12.177 126.072-12.158 27.672-14.569 54.905-30.725 82.829-44.375 34.102 31.053 67.971 62.407 101.986 93.574 60.178 58.44 150.176-46.197 82.541-96.955-36.542-32.947-71.857-67.336-109.254-99.28-41.494-31.248-101.626-32.596-145.121-4.529-29.324 15.566-58.339 32.416-87.852 47.205-64.376-37.387-129.476-74.19-193.38-111.977-.023-13.597.009-27.197-.015-40.792z"
      className="cls-1"
    ></path>
    <path
      fill="#8b2c32"
      fillOpacity="1"
      stroke="none"
      strokeDasharray="none"
      strokeOpacity="1"
      strokeWidth="1.002"
      d="M320.87 0c-44.397-1.327-79.795 28.005-116.893 47.87-49.686 29.053-100.07 56.99-149.315 86.747C16.1 160.421-3.198 207.821.037 253.211c-.044 56.083-.005 112.167-.02 168.25 42.354-.16 85.303.32 127.284-.24.216-60.775-.48-121.895.348-182.453 64.537-37.116 128.96-75.117 193.744-111.395 64.363 37.35 129.505 74.078 193.27 112.03-.043 61.238.02 122.477-.032 183.716-3.307 86.471 134.005 78.873 127.299-2.11-.336-64.327.638-128.669-.514-192.987-3.317-46.173-34.493-86.806-75.677-106.502C502.08 85.13 439.03 47.615 374.979 11.955 358.102 4.07 339.489.015 320.869 0z"
      className="cls-1"
    ></path>
    <path
      fill="none"
      fillOpacity="1"
      strokeDasharray="none"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.002"
      d="M701.12 424.62c185.288 2.11 333.976 38.97 333.976 38.97l317.963 67.683 84.065 206.447-221.316 59.475L713.701 609.62z"
    ></path>
  </svg>
);

